import React, { useEffect, useState } from "react";
import CoachLayout from "../common/CoachLayout";
import { useCoachAuthContext } from "../login/useCoachAuthContext";
import { Link } from "react-router-dom";
import API_URL from "../../api/API";
import ladyRun from "../../images/ladyRun.png";

export const CoachPurchaseStaticSpeedTemplates = () => {
  const { coach } = useCoachAuthContext();
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchTemplates = async () => {
    try {
      const response = await fetch(API_URL.GET_COACH_STATIC_WORKOUT_TEMPLATES_FRONT, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${coach.token}`,
        },
      });

      // Check if the response is successful
      if (!response.ok) {
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }

      const data = await response.json();
      setTemplates(data); // Assuming the API sends back the formatted templates
    } catch (err) {
      setError(err.message);
      console.error("Error fetching workout templates:", err);
    } finally {
      setLoading(false); // Ensure loading state is set to false after fetch completes
    }
  };

  useEffect(() => {
    fetchTemplates();
  }, []);

  return (
    <CoachLayout>
      <div className="min-h-min h-full bg-[#F6F6F6]">
        <div className="w-full max-w-2xl mx-auto px-5">
          {/* Back button */}
          <div className="py-5">
            <Link
              to="/coach/tools" // Route to go back
              className="flex items-center gap-2 text-black font-bold text-sm"
            >
              <span className="w-4 h-4 border-[1.5px] border-black border-solid rotate-45 border-t-0 border-r-0"></span>
              Back
            </Link>
          </div>

          <div className="tabbing p-5" id="default-tab-content">
            {/* Tab header */}
            <div className="flex flex-row justify-center gap-[104px] mb-2">
              <p className={`text-base font-normal pb-[11px] cursor-pointer text-black border-b border-black`}>
                Speed
              </p>

              <Link to="/coach/purchase/static-strength-templates">
                <p className={`text-base font-normal pb-[11px] cursor-pointer text-[#A5A5A5]`}>
                  Strength
                </p>
              </Link>
            </div>

            {/* Conditional Rendering for Loading, Error, or Data */}
            {loading && (
              <div className="flex justify-center items-center h-full">
                <p>Loading templates...</p>
              </div>
            )}

            {error && (
              <div className="flex justify-center items-center h-full">
                <p className="text-red-500">Error: {error}</p>
              </div>
            )}

            {!loading && !error && templates.length === 0 && (
              <div className="flex justify-center items-center h-full">
                <p>No templates available at the moment.</p>
              </div>
            )}

            {!loading && !error && templates.length > 0 && (
              <div className="flex flex-wrap justify-center gap-x-[10px] gap-y-5 py-3 w-full max-w-[370px] mx-auto">
                {templates.map((template) => (
                  <Link
                    to={`/coach/purchase/static-speed-template-detail/${template.template_id}`}
                    key={template.template_id}
                  >
                    <div className="flex flex-col">
                      <div className="w-[169px] h-[169px] rounded-[15px] overflow-hidden mb-3">
                        {
                          template.photo? (
                            <img
                            src={`${API_URL.SERVER_PICTURE_URL}${template.photo}`}
                            alt={template.title}
                             className="w-full h-full object-cover"
                          />
                          ):(
                            <img
                            src={ladyRun}
                            alt={template.title}
                            className="w-full h-full object-cover"
                          />
                          )
                        }
                      </div>
                      <p className="text-black text-base font-normal">
                        {template.title}
                      </p>
                      <span className="text-black text-sm font-light openSans">
                        ${template.price}
                      </span>
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </CoachLayout>
  );
};
